import Controller from '@ember/controller';
import { action } from '@ember/object';
import SetupGuide, { IntegrationMethod } from 'cio/models/setup-guide';
import moment from 'moment-timezone';

export default class SetupGuideSourcesController extends Controller {
  queryParams = ['integrationMethod'];

  model!: SetupGuide;
  integrationMethod: IntegrationMethod | null = null;

  reset() {
    this.set('integrationMethod', null);
  }

  @action
  onSelect(integrationMethod: IntegrationMethod, integrationConnectedAt: number | null = null) {
    this.set('integrationMethod', integrationMethod);

    this.model.setProperties({
      integrationMethod,
      integrationConnectedAt,
    });

    return this.model.save();
  }

  @action
  onComplete() {
    this.model.set('integrationCompletedAt', moment().unix());
    return this.model.save();
  }
}
